import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Button } from "reactstrap";
import jp from 'jsonpath';
import classnames from "classnames";
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { setPostFeedBody, setPreview, setSelectedFieldIdx, setSelectedFieldPath, setSelectedFieldTargetUrl, setSelectedFields, setSelectedOperationPath, setSelectedPath, setSourceData } from '../../../slices/feeds/reducer';
import ModalSelectBox from './ModalSelectBox';
import { toggleAddFieldModal } from '../../../slices/modals/reducer';

function SelectField() {
  const dispatch = useDispatch();

  const selectFieldsState = createSelector((state) => state.Feed, (state) => ({
    sourceDataFields: state.sourceDataFields,
    selectedPath: state.selectedPath,
    isAddingNewFeed: state.isAddingNewFeed,
    selectedFields: state.selectedFields,
    mappedSource: state.mappedSource,
    sourceData: state.sourceData,
    feedInfo: state.feedInfo,
    selectedFieldIdx: state.selectedFieldIdx
  }));
  const {
    sourceDataFields, selectedPath, isAddingNewFeed, selectedFields, mappedSource, sourceData, feedInfo, selectedFieldIdx } = useSelector(selectFieldsState);
  const selectFeedModalType = createSelector((state) => state.Modal, (state) => state.feedModalType);
  const feedModalType = useSelector(selectFeedModalType);

  console.log('sourceDataFields', sourceDataFields);
  console.log('feedInfo', feedInfo);
  

  useEffect(() => {
    if (selectedFields) {
      if (feedModalType === "feed") {
        dispatch(setPreview(selectedFields));
      }
      dispatch(setPostFeedBody({ feed: selectedFields }));
    }
  }, [selectedFields]);

  function selectArray(item, key) {
    if (selectedFields.length > 0) {
      dispatch(setSelectedFields([]))
    } else {
      let foundFields = sourceDataFields.filter(fieldItem => fieldItem.path.includes(item.path) && fieldItem.depth === (item.depth + 1) && fieldItem.isObj === false);
      dispatch(setSelectedFields(foundFields));
    }
  }

  function handleSelect(item, key) {
    if (feedModalType === "feed" || feedModalType === "field") {
      const foundField = selectedFields.find(selectedItem => selectedItem.key === key);
      if (foundField !== undefined) {
        dispatch(setSelectedFields(selectedFields.filter(selectedItem => selectedItem.key !== key)));
      } else {
        dispatch(setSelectedFields([...selectedFields, { ...item }]))
      }
    } else if (feedModalType === "targetfield") {
      // dispatch(setSelectedFieldTargetUrl(item.path));
      dispatch(setSelectedFieldPath({idx: selectedFieldIdx, path: item.path}));
      dispatch(toggleAddFieldModal());
    } else if (feedModalType === "operation") {
      dispatch(setSelectedOperationPath(item));
      dispatch(toggleAddFieldModal());
    }
  }

  const [oldSelectedPath, setOldSelectedPath] = useState((selectedPath || ""));
  return (
    <Card className='bg-light border-0 shadow-none'>
      <CardHeader className='d-flex align-items-center justify-content-between bg-light border-0'>
        <p className='m-0'>
          <i className='ri-drag-move-fill align-bottom handle me-2'></i>
          {/* <b>{selectedPath}</b> {fields[0].values.length} items */}
        </p>
        {/* {(feedModalType !== "operation" && feedModalType !== "targetfield") ?
          <React.Fragment>
            {isSelectedAll === false ?
              <Button color='soft-info' size='sm' className='px-3' onClick={selectAll}>Select All</Button>
              :
              <Button color='soft-danger' size='sm' className='px-3' onClick={deselectAll}>Deselect All</Button>
            }
          </React.Fragment>
          : null} */}
      </CardHeader>
      <CardBody className='border-0 pt-0'>
        <div className='w-100 d-flex flex-column align-items-end gap-1 ps-0'>
          {feedModalType !== 'operation' && sourceDataFields !== null ? sourceDataFields.map((item, key) => {
            if (item.values.length > 0) {
              if (typeof item.values[0] === "object") {
                return (
                  <ModalSelectBox
                    key={item.key}
                    name={item.name}
                    icon={'ri-drag-move-fill'}
                    values={item.values.length > 0 ? `${item.values.length} items` : '[]'}
                    style={{ width: `calc(100% - ${(item.path.split('.').length - 1) * 25}px)` }}
                    classnames={classnames({ "bg-info-subtle": selectedFields.find(selectedItem => selectedItem.key === item.key) !== undefined })}
                    handleSelect={() => selectArray(item, item.key)}
                  />
                )
              } else if (typeof item.values[0] === "string" || typeof item.values[0] === "number") {
                return (
                  <ModalSelectBox
                    key={item.key}
                    name={item.name}
                    values={item.values.join(', ')}
                    style={{ width: `calc(100% - ${(item.path.split('.').length - 1) * 25}px)` }}
                    classnames={classnames({ "bg-info-subtle": selectedFields.find(selectedItem => selectedItem.key === item.key) !== undefined })}
                    handleSelect={() => handleSelect(item, item.key)}
                  />
                )
              }
            } else {
              return (
                <ModalSelectBox
                  key={item.key}
                  name={item.name}
                  values={"[]"}
                  style={{ width: `calc(100% - ${(item.path.split('.').length - 1) * 25}px)` }}
                  classnames={classnames({ "bg-info-subtle": selectedFields.find(selectedItem => selectedItem.key === item.key) !== undefined })}
                  handleSelect={() => handleSelect(item, item.key)}
                />
              )
            }
          }) : null}
          {feedModalType === 'operation' ? feedInfo.feed.map((item, idx) => {
              return (
                <ModalSelectBox
                  key={item.key}
                  name={item.name}
                  values={item.values}
                  style={{ width: `100%` }}
                  classnames={classnames({ "bg-info-subtle": selectedFields.find(selectedItem => selectedItem.key === item.key) !== undefined })}
                  handleSelect={() => handleSelect(item, item.key)}
                />
              ) 
          }) : null}
        </div>
      </CardBody>
    </Card>
  )
}

export default SelectField;